import { Flex, Stack, Text } from "@mantine/core";
import { ButtonCheckboxV1 } from "./ButtonCheckboxV1";
import type { ButtonToggleProps } from "./ButtonToggle";

export const ButtonToggleV1 = ({
  value,
  onChange,
  align = "center",
  trueLabel,
  falseLabel,
  error,
}: ButtonToggleProps) => {
  return (
    <Stack>
      <Flex w="100%">
        <ButtonCheckboxV1
          id="true"
          onClick={() => onChange(true)}
          isActive={value ?? false}
          align={align}
          error={error}
          style={{
            minHeight: "100%",
            width: "100%",
          }}
        >
          {trueLabel}
        </ButtonCheckboxV1>
        <ButtonCheckboxV1
          id="false"
          onClick={() => onChange(false)}
          isActive={value === false}
          error={error}
          align={align}
          style={{
            minHeight: "100%",
            width: "100%",
          }}
        >
          {falseLabel}
        </ButtonCheckboxV1>
      </Flex>
      {error && (
        <Text size="xs" c="red">
          {error}
        </Text>
      )}
    </Stack>
  );
};
